module.exports = __webpack_public_path__ + "static/logo_footer-77d5ba3bd1388aa27d944e0e741ad7a3.svg";